let modalCount = 0;
let previousOverflow = '';
export function modalFocus(node) {
  if (!modalCount++) { previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; }
  const previous = document.activeElement;
  node.focus();
  function trap(event) {
    if (event.key !== 'Tab') return;
    const controls = [...node.querySelectorAll('button:not(:disabled),input:not(:disabled),select:not(:disabled),textarea:not(:disabled),a[href]')].filter(item => item.getClientRects().length);
    const first = controls[0]; const last = controls.at(-1);
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || document.activeElement === node)) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || document.activeElement === node)) { event.preventDefault(); first.focus(); }
  }
  node.addEventListener('keydown', trap);
  return { destroy() {
    node.removeEventListener('keydown', trap);
    if (!--modalCount) document.body.style.overflow = previousOverflow;
    if (previous instanceof HTMLElement && previous.isConnected) previous.focus();
  } };
}
